import TransactionTable from "./TransactionsTable";

const Transactions = () => {
	return (
		<>
			<div className="component-body">
				<div className="page-title">
					<h2>Transactions</h2>
				</div>

				<div className="mt-3">
					<TransactionTable />
				</div>
			</div>
		</>
	)
}

export default Transactions;